import axios from 'axios';

const api = axios.create({
    // baseURL: 'http://localhost:3000',
    // baseURL: 'https://2926f099bcf1.ngrok-free.app',
    baseURL: 'https://api.istmech.edu.ht',
    headers: {
        'Content-Type': 'application/json',
        'ngrok-skip-browser-warning': 'true',
    },
});

// Add a request interceptor to add the JWT token to every request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('istmech_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
// Add a response interceptor to handle token refresh and errors
api.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const originalRequest = error.config;

        // Handle Network Errors (Server down, CORS, etc.)
        if (!error.response) {
            console.error('Network Error:', error);
            // Dynamic import to avoid circular dependency if possible, or assume toast is available
            // Since we can't use hooks here directly, we might need a workaround or just simple alert/console for now
            // But user specifically asked for "explicit message".
            // Directtoast usage might tricky outside React component if it relies on context but shadcn toast has a toaster.
            // Let's rely on event dispatch or just console log if we can't easily toast.
            // BUT wait, `src/hooks/use-toast.ts` exports `toast` function which interacts with the store. It CAN be used outside components!
            const { toast } = await import('../hooks/use-toast');
            toast({
                variant: 'destructive',
                title: "Erreur de connexion",
                description: "Impossible de joindre le serveur. Vérifiez votre connexion internet ou réessayez plus tard."
            });
            return Promise.reject(error);
        }

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshToken = localStorage.getItem('istmech_refresh_token');

                if (!refreshToken) {
                    throw new Error('No refresh token available');
                }

                // Call refresh endpoint using the same base URL
                const response = await api.post('/auth/refresh', {
                    refresh_token: refreshToken
                });

                const { access_token, refresh_token } = response.data;

                // Update localStorage
                localStorage.setItem('istmech_token', access_token);
                if (refresh_token) {
                    localStorage.setItem('istmech_refresh_token', refresh_token);
                }

                // Update Authorization header for original request
                originalRequest.headers.Authorization = `Bearer ${access_token}`;

                return api(originalRequest);
            } catch (authError) {
                // If refresh fails, clear everything and redirect to login
                localStorage.removeItem('istmech_token');
                localStorage.removeItem('istmech_refresh_token');
                localStorage.removeItem('istmech_user');
                if (window.location.pathname !== '/login') {
                    window.location.href = '/login';
                }
                return Promise.reject(authError);
            }
        }

        // Handle 500 errors
        if (error.response?.status >= 500) {
            const { toast } = await import('../hooks/use-toast');
            toast({
                variant: 'destructive',
                title: "Erreur Serveur",
                description: "Une erreur interne est survenue. L'équipe technique a été notifiée."
            });
        }

        return Promise.reject(error);
    }
);
export default api;
